// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { TABBAR_ITEM_TRANSITION } from '../../../constants/ui/tabbar';
import theme from '../../../styled-components/dark';

const SvgElement = styled.svg`
  ${({ $isActive }) =>
    $isActive
      ? css`
          --circle-active-path-fill: ${theme.TabBar.Button.default.active.color};
          --circle-passive-path-fill: transparent;
          --stick-active-path-fill: ${theme.TabBar.Button.default.active.color};
          --stick-passive-path-fill: transparent;
        `
      : css`
          --circle-active-path-fill: transparent;
          --circle-passive-path-fill: ${theme.TabBar.Button.default.passive.color};
          --stick-active-path-fill: transparent;
          --stick-passive-path-fill: ${theme.TabBar.Button.default.passive.color};
        `}
`;

const sharedPathTransition = css`
  transition: fill ${TABBAR_ITEM_TRANSITION}ms ease-in-out;
`;

const CircleActivePath = styled.path`
  ${sharedPathTransition}
  fill: var(--circle-active-path-fill, transparent);
`;

const StickActivePath = styled.path`
  ${sharedPathTransition}
  fill: var(--stick-active-path-fill, transparent);
`;

const CirclePassivePath = styled.path`
  ${sharedPathTransition}
  fill: var(--circle-passive-path-fill, transparent);
`;

const StickPassivePath = styled.path`
  ${sharedPathTransition}
  fill: var(--stick-passive-path-fill, transparent);
`;

type SportsIconSvgAsComponentProps = {
  isActive?: boolean;
  className?: string;
};

const SportsIconSvgAsComponent = ({ className, isActive = false }: SportsIconSvgAsComponentProps) => {
  return (
    <SvgElement className={className} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" $isActive={isActive}>
      <CircleActivePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6288 18.6287C21.4613 15.7962 21.4613 11.2038 18.6288 8.37132C15.7963 5.53882 11.2039 5.53882 8.37145 8.37132C5.53894 11.2038 5.53894 15.7962 8.37145 18.6287C11.2039 21.4612 15.7963 21.4612 18.6288 18.6287ZM20.7502 20.75C24.7542 16.746 24.7542 10.2541 20.7502 6.25C16.7461 2.24593 10.2542 2.24593 6.25013 6.25C2.24605 10.2541 2.24605 16.746 6.25013 20.75C10.2542 24.7541 16.7461 24.7541 20.7502 20.75Z"
      />
      <StickActivePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6894 19.6894C20.2752 19.1036 21.225 19.1036 21.8108 19.6894L26.48 24.3586C27.0658 24.9444 27.0658 25.8942 26.48 26.48C25.8943 27.0657 24.9445 27.0657 24.3587 26.48L19.6894 21.8107C19.1037 21.2249 19.1037 20.2751 19.6894 19.6894Z"
      />
      <CirclePassivePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3359 19.3358C22.559 16.1128 22.559 10.8872 19.3359 7.66422C16.1129 4.44119 10.8874 4.44119 7.66434 7.66422C4.44131 10.8872 4.44131 16.1128 7.66434 19.3358C10.8874 22.5589 16.1129 22.5589 19.3359 19.3358ZM20.7502 20.75C24.7542 16.746 24.7542 10.2541 20.7502 6.25C16.7461 2.24593 10.2542 2.24593 6.25013 6.25C2.24605 10.2541 2.24605 16.746 6.25013 20.75C10.2542 24.7541 16.7461 24.7541 20.7502 20.75Z"
      />
      <StickPassivePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.043 20.0429C20.4335 19.6524 21.0667 19.6524 21.4572 20.0429L26.4416 25.0273C26.8321 25.4178 26.8321 26.051 26.4416 26.4415C26.0511 26.832 25.4179 26.832 25.0274 26.4415L20.043 21.4571C19.6525 21.0666 19.6525 20.4334 20.043 20.0429Z"
      />
    </SvgElement>
  );
};

export default SportsIconSvgAsComponent;
